import { faMagic } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner, StyledInput } from '@ui';
import InputButton from '@ui/InputButton';
import { useClubSlug } from 'components/Clubs/hooks';
import { FormInput } from 'components/Form/next';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

interface Props {
    name?: string;
    label?: string;
    preview?: boolean;
    pattern?: string;
}

export const ClubMemberNumberField = ({
    name = 'number',
    label,
    preview = false,
    pattern = null
}: Props) => {
    const { t } = useTranslation('member-management');
    const resolvedLabel = label ?? t('clubMember.form.fields.memberNumber');
    const clubSlug = useClubSlug();
    const { setValue, getValues } = useFormContext();
    const [value, _setValue] = useState('');
    const [manual, _setManual] = useState(!preview ? getValues()[name] !== undefined : false);
    const url = `club-member/${clubSlug}/number`;
    const { data, error, mutate } = useSWR(!manual ? (pattern ? [url, { pattern }] : url) : null, null, {
        onSuccess: (data) => {
            preview ? _setValue(data?.number) : setValue(name, data?.number);
        }
    });
    const isLoading = !manual && !data && !error;

    const setManual = (value: boolean) => {
        _setManual(value);
        if (!value) {
            mutate();
        }
    };

    return preview ? (
        <StyledInput value={value} disabled css={{ w: '100%' }} />
    ) : (
        <FormInput
            disabled={!manual}
            name={name}
            label={resolvedLabel}
            contentRightStyling={false}
            contentRight={
                isLoading ? (
                    <Spinner size="xs" />
                ) : (
                    !preview && (
                        <InputButton color={manual ? 'warning' : 'success'} onPress={() => setManual(!manual)}>
                            <FontAwesomeIcon icon={faMagic} />
                        </InputButton>
                    )
                )
            }
        />
    );
};
